export enum PeerActivityStatus {
    STATUS_FINAL = "F",
    STATUS_NEW = "N",
    STATUS_ON_PUBLISH = "OP",
    STATUS_ERROR = "E",
    STATUS_READY = 'R',
    STATUS_UNPUBLISHED = 'UP',
    STATUS_PUBLISHING = 'PI',
    STATUS_AWAITING_APPROVAL = 'AA',
    STATUS_REJECTED = 'RJ'
}

export enum PeerActivityStatusClass {
    STATUS_FINAL = "success",
    STATUS_NEW = "primary",
    STATUS_ON_PUBLISH = "info",
    STATUS_ERROR = "danger",
    STATUS_AWAITING_APPROVAL = "warning",
    STATUS_REJECTED = "danger",
}